import { computed, ref, watch, unref, onBeforeUnmount } from 'vue';
import { cacheBustedURL } from 'dashboard/helper/URLHelper';

export const useRetryableMediaSource = (sourceRef, config = {}) => {
  const maxRetry = config.max_retry || 3;
  const backoff = config.backoff || 1000;

  const retryAttempt = ref(0);
  const hasError = ref(false);
  let retryTimeoutId = null;

  const reset = () => {
    retryAttempt.value = 0;
    hasError.value = false;
    if (retryTimeoutId) {
      clearTimeout(retryTimeoutId);
      retryTimeoutId = null;
    }
  };

  const source = computed(() => {
    const baseUrl = unref(sourceRef);
    if (!baseUrl) return '';
    if (retryAttempt.value === 0) return baseUrl;

    return cacheBustedURL(baseUrl, `${Date.now()}-${retryAttempt.value}`);
  });

  const scheduleRetry = () => {
    if (retryAttempt.value >= maxRetry) {
      hasError.value = true;
      return;
    }

    const nextAttempt = retryAttempt.value + 1;
    if (retryTimeoutId) clearTimeout(retryTimeoutId);

    retryTimeoutId = setTimeout(() => {
      retryAttempt.value = nextAttempt;
    }, backoff * nextAttempt);
  };

  watch(sourceRef, () => reset());
  onBeforeUnmount(() => reset());

  return {
    source,
    hasError,
    scheduleRetry,
    reset,
  };
};
